// extracted by mini-css-extract-plugin
export default {"naturalIterfaceIcon":"style_naturalIterfaceIcon__UYPFi"};